import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "children", "Button", "result", "theme", "currentState", "onClick"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import VizExLoadingSpinner from '../loading/VizExLoadingSpinner';
import LoadingButtonUses, { buttonUse, spinnerUse } from './constants/LoadingButtonUses';
import themePropType from '../utils/themePropType';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Spinner = styled(VizExLoadingSpinner).withConfig({
  displayName: "VizExLoadingButton__Spinner",
  componentId: "sc-1ievgt7-0"
})(["height:0;position:absolute;top:50%;right:0;transition:opacity 0.2s;opacity:", ";"], ({
  show
}) => show ? 1 : 0);
const ReadyWrapper = styled.div.withConfig({
  displayName: "VizExLoadingButton__ReadyWrapper",
  componentId: "sc-1ievgt7-1"
})(["transition:opacity 0.2s;opacity:", ";"], ({
  show
}) => show ? 1 : 0);
const VizExLoadingButton = _ref => {
  let {
      use = LoadingButtonUses.PRIMARY,
      children,
      Button,
      result,
      theme,
      currentState,
      onClick = () => {}
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isReady = currentState === 'ready';
  const isSubmitting = currentState === 'submitting';
  const isDone = currentState === 'done';
  return /*#__PURE__*/_jsxs(Button, Object.assign({
    theme: theme,
    onClick: isSubmitting || isDone ? () => {} : onClick,
    use: buttonUse(use),
    style: {
      position: 'relative'
    },
    "data-test-id": "loading-button"
  }, rest, {
    children: [/*#__PURE__*/_jsx(ReadyWrapper, {
      "data-test-id": "VizExLoadingButton-Ready",
      show: isReady,
      children: children
    }), /*#__PURE__*/_jsx(Spinner, {
      size: "xs",
      grow: true,
      use: spinnerUse(use),
      theme: theme,
      showResult: isDone,
      show: isSubmitting || isDone,
      "data-test-id": "VizExLoadingButton-Spinner",
      children: result
    })]
  }));
};
VizExLoadingButton.propTypes = {
  Button: PropTypes.elementType.isRequired,
  children: PropTypes.node.isRequired,
  currentState: PropTypes.oneOf(['ready', 'submitting', 'done']),
  onClick: PropTypes.func,
  result: PropTypes.node,
  theme: themePropType,
  use: PropTypes.oneOf(Object.values(LoadingButtonUses))
};
VizExLoadingButton.displayName = 'VizExLoadingButton';
export default VizExLoadingButton;